export default {
  payment_gateway: {
    code: 'Gateway Code',
    provider: 'Provider',
    provider_select: 'Select a provider',
    provider_alert:
      'Please note that once you have connected a provider to this payment gateway, you won’t be able to remove or edit it later.',
    connected: 'Connected',
    view_details: 'View details',
    currency: 'Default Currency',
    payment_alert: 'You currently cannot receive payments',
    payment_alert_message:
      'You currently cannot receive payments due to possible restrictions on your account. Please reach out to Customer Support for more information.',
    stripe: {
      name: 'Stripe',
      action_title: 'Link your Stripe account to Fourwaves',
      action_subtitle: 'You might need to create it first',
      action_cta: 'Go to Stripe',
      error_message: 'Please connect your Stripe account.',
      modal: {
        title: 'Stripe Configuration',
        publishable_key: 'Publishable Key',
        secret_key: 'Secret Key',
      },
    },
    globalpayments: {
      name: 'Global Payments',
      modal: {
        title: 'Global Payments Configuration',
        app_key: 'App Key',
      },
    },
    touchnet: {
      name: 'TouchNet',
      modal: {
        title: 'TouchNet Configuration',
        tlink_url: 'TLink URL',
        upay_site_url: 'uPay Site URL',
        upay_site_id: 'uPay Site ID',
      },
    },
    moneris: {
      name: 'Moneris',
      modal: {
        title: 'Moneris Configuration',
        tlink_url: 'TLink URL',
        upay_site_url: 'uPay Site URL',
        upay_site_id: 'uPay Site ID',
      },
    },
    paypal: {
      name: 'PayPal',
      action_title: 'Link your PayPal account to Fourwaves',
      action_subtitle: 'You might need to create it first',
      action_cta: 'Go to PayPal',
      error_message: 'Please connect your PayPal account.',
      modal: {
        title: 'PayPal Configuration',
        merchantId: 'Merchant ID',
        email: 'Primary Email',
        scopes: 'Scopes',
        email_alert_message: 'Please confirm your email address on PayPal in order to receive payments.',
        payment_alert_message:
          'You currently cannot receive payments due to possible restrictions on your PayPal account. Please reach out to PayPal Customer Support for more information',
        advanced_payments_alert_message:
          'Please enable custom advanced credit and debit card payments on your PayPal account.',
      },
    },
    creation_modal: {
      title: 'Connect Payment Gateway',
      info: 'General Info',
      connection: 'Select Provider',
    },
    edition_modal: {
      title: 'Edit Payment Gateway',
    },
    delete_modal: {
      title: 'Delete Payment Gateway',
      subtitle: 'Are you sure you want to delete this payment gateway?',
      item: 'Payment Gateway',
      unavailable_title: 'Deletion Unavailable',
      unavailable_subtitle:
        'This payment gateway is connected to one or more events. Please unlink all events before you can delete it.',
    },
    request_connection_state: {
      accepted: 'Approved',
      waiting: 'Pending Approval',
      refused: 'Rejected',
      correctionrequired: 'Modification Required',
    },
    decision_modal: {
      title: 'Connection request',
      connection_form: 'Connection Form',
      decision: 'Decision',
      decision_message:
        'By accepting, the payment gateway will be connected to the event. A notification will be sent by email to the requester.',
      decision_select: 'Your decision',
      notes: 'Note for the requester',
      save: 'Save the decision',
      costs: 'Costs and taxes of the event',
    },
  },
};
